import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IBetalingStatus } from '@/model/IBetalingStatus';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component({})
export default class AppBetalingSucces extends Mixins(AppFiltersMixin) {
  @Prop()
  public status!: IBetalingStatus;
}
